import React, { useState, useEffect } from 'react';
import './App.css';
import SignUp from './SignUp';
import Login from './Login';
import ChatbotApp from './ChatbotApp';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [tokens, setTokens] = useState(null);

  // 🧠 Auto-login logic for dev
  useEffect(() => {
    const storedToken = localStorage.getItem('idToken');
    if (storedToken) {
      setTokens({ idToken: storedToken });
      setLoggedIn(true);
    }

    // 👇 Uncomment for development-only auto-login
    // const devToken = {
    //   idToken: 'eyJraWQiOi...YOUR_DEV_JWT_TOKEN...',
    // };
    // setTokens(devToken);
    // setLoggedIn(true);
  }, []);

  return (
    <div className="App">
      {loggedIn ? (
        <ChatbotApp tokens={tokens} />
      ) : (
        <div className="auth-container">
          <h1 className="auth-heading">Lulu Kid Friendly</h1>

          {showSignUp ? (
            <SignUp
              onSuccess={() => {
                alert('Account created! Please log in.');
                setShowSignUp(false);
              }}
              onError={(msg) => alert(msg)}
            />
          ) : (
            <Login
              onLoginSuccess={(token) => {
                console.log('Logged in token:', token);
                setTokens(token);
                setLoggedIn(true);
                localStorage.setItem('idToken', token.idToken); // ✅ persist login
              }}
              onError={(msg) => alert(msg)}
            />
          )}

          <button
            className="toggle-button"
            onClick={() => setShowSignUp((prev) => !prev)}
          >
            {showSignUp ? 'Back to Login' : 'Create an Account'}
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
